
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuthCustomer } from "../../components/hooks/useAuthCustomer";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Header() {
    const { customer } = useAuthCustomer();
    const navigate = useNavigate();

    useEffect(() => {
        if (!customer) {
            Swal.fire({
                icon: "warning",
                title: "Chưa đăng nhập",
                text: "Bạn phải đăng nhập rồi mới tiếp tục",
                confirmButtonText: "Đăng nhập",
            }).then(() => {
                navigate("/login", { replace: true });
            });
        }
    }, [customer, navigate]);

    const handleLogout = async () => {
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Logout failed", error);
        } finally {
            localStorage.removeItem("access_token");
            localStorage.removeItem("customer");
            window.location.href = "/login";
        }
    };

    useEffect(() => {
        const sidebar = document.querySelector('.sidebar');
        const container_menu_toggle = document.querySelector('.container_menu_toggle');
        const close_menu_toggle = document.querySelector('.close_menu_toggle');
        const account = document.querySelector('.account');
        const account_toggle = document.querySelector('.account-toggle');

        if (!sidebar || !container_menu_toggle || !close_menu_toggle || !account || !account_toggle) return;

        const handleSidebar = () => {
            sidebar.classList.toggle('active');
            container_menu_toggle.classList.toggle('active');
            account_toggle.classList.remove('show');
        };

        const handleAccount = () => {
            account_toggle.classList.toggle('show');
        };

        const handleOutsideClick = (e: MouseEvent) => {
            if (
                account_toggle.classList.contains('show') &&
                !account_toggle.contains(e.target as Node) &&
                !account.contains(e.target as Node)
            ) {
                account_toggle.classList.remove('show');
            }
        };

        const handleCloseMenu = () => {
            sidebar.classList.remove('active');
            container_menu_toggle.classList.remove('active');
        };

        sidebar.addEventListener('click', handleSidebar);
        account.addEventListener('click', handleAccount);
        document.addEventListener('click', handleOutsideClick);
        close_menu_toggle.addEventListener('click', handleCloseMenu);

        return () => {
            sidebar.removeEventListener('click', handleSidebar);
            account.removeEventListener('click', handleAccount);
            document.removeEventListener('click', handleOutsideClick);
            close_menu_toggle.removeEventListener('click', handleCloseMenu);
        };
    }, []);

    return (
        <div className="header">
            <nav className="nav">
                <div className="content_nav">
                    <a href={`${process.env.REACT_APP_LINK_URL}/photo`} className="nav_link">IN ẢNH</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/album`} className="nav_link">IN ALBUM</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/sticker`} className="nav_link">HÌNH STICKER</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/calendar`} className="nav_link">IN LỊCH</a>
                </div>
            </nav>
            <div className="container_menu">
                <Link className="logo" to={`${process.env.REACT_APP_LINK_URL}`}>
                    {/* <img src={`${process.env.REACT_APP_LINK_URL}/`} alt={`${process.env.REACT_APP_LINK_URL}/`} /> */}
                    <p>PRI.VN</p>
                </Link>

                <div className="menu">
                    <a href={`${process.env.REACT_APP_LINK_URL}/photo`} className="menu_link">IN ẢNH</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/price`} className="menu_link">ĐƠN GIÁ</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/size`} className="menu_link">SIZE</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/guide`} className="menu_link">CÁCH ĐẶT HÀNG</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/faq`} className="menu_link">Q&A</a>
                    <a href={`${process.env.REACT_APP_LINK_URL}/sale`} className="menu_link">CHƯƠNG TRÌNH KHUYẾN MẠI</a>
                </div>
                <div className="widget">
                    <div className="account">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-person"
                            viewBox="0 0 16 16">
                            <path
                                d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                        </svg>
                        <p>Tài khoản</p>
                        <div className="account-toggle">
                            {customer && (
                                <>
                                    <Link to={`/profile`} className="toggle-link">HỒ SƠ</Link>
                                    <Link to={`/history`} className="toggle-link">LỊCH SỬ ĐẶT HÀNG</Link>
                                    <Link to={`/re-password`} className="toggle-link">ĐỔI MẬT KHẨU</Link>
                                    <button onClick={handleLogout} className="toggle-link">ĐĂNG XUẤT</button>
                                </>
                            )}
                            {!customer && (
                                <>
                                    <Link to={`/register`} className="toggle-link">ĐĂNG KÍ TÀI KHOẢN MỚI</Link>
                                    <Link to={`/login`} className="toggle-link">ĐĂNG NHẬP</Link>
                                </>
                            )}
                            {/* <a href={`${process.env.REACT_APP_LINK_URL}/`} className="toggle-link">TÍCH ĐIỂM</a> */}
                        </div>
                    </div>
                    <div className="sidebar">
                        <div className="overlay"></div>
                        <button className="icon_sidebar">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <p>Menu</p>
                    </div>
                    <div className="container_menu_toggle">
                        <p className="close_menu_toggle">
                            <span></span>
                            <span></span>
                        </p>
                        <div className="menu_toggle">
                            <div className="item">
                                <p className="title">SẢN PHẨM</p>
                                <div className="content_item">
                                    <a href={`${process.env.REACT_APP_LINK_URL}/photo`}>In Ảnh</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/album`}>In Album</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/calendar`}>In Lịch</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/sticker`}>In Sticker</a>
                                </div>
                            </div>
                            <div className="item">
                                <a href={`${process.env.REACT_APP_LINK_URL}/size`} className="title">SIZE</a>
                            </div>
                            <div className="item">
                                <a href={`${process.env.REACT_APP_LINK_URL}/guide`} className="title">CÁCH ĐẶT HÀNG</a>
                            </div>
                            <div className="item">
                                <a href={`${process.env.REACT_APP_LINK_URL}/faq`} className="title">Q&A</a>
                            </div>
                            <div className="item">
                                <a href={`${process.env.REACT_APP_LINK_URL}/sale`} className="title">CHƯƠNG TRÌNH KHUYẾN MẠI</a>
                            </div>
                            <div className="item">
                                <p className="title">GIỚI THIỆU</p>
                                <div className="content_item">
                                    <a href={`${process.env.REACT_APP_LINK_URL}/company`}>Giới thiệu</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/terms`}>Điều khoản sử dụng</a>
                                </div>
                                <div className="content_item">
                                    <a href={`${process.env.REACT_APP_LINK_URL}/privacy-policy`}>Chính sách bảo mật</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/harassment-policy`}>Chính sách chống quấy rối</a>
                                </div>
                                <div className="content_item">
                                    <a href={`${process.env.REACT_APP_LINK_URL}/content-policy`}>Chính sách nội dung</a>
                                    <a href={`${process.env.REACT_APP_LINK_URL}/sitemap`}>Sơ đồ trang web</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;